// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1jI1G","title":"AfterBackImages_title__FXmT8","images":"AfterBackImages_images__2Q_Ym"};